import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "../global";

const actions = () => ({
  googleLogin() {
    const url = import.meta.env.VITE_API_URL;
    window.location.href = url + "/oauth2/authorization/google";
  },

  async getUserData() {
    const response = await api.get("/api/user/data");
    this.user = response.data;
    this.authenticated = true;
    localStorage.setItem("roles", JSON.stringify(this.user.roles));
  },

  async addUserData(payload) {
    try {
      await api.post("/api/user/admin/add", payload);

      if (payload.image) {
        const formData = new FormData();
        formData.append("file", payload.image);

        await api.post(`/api/files/${payload.id}/upload/user_photo`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      this.user = await this.getUserData();
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "All changes have been saved!",
        timeout: 3000,
        type: "success",
        position: "top",
      });
    } catch (err) {
      console.log(err);
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "All changes have been saved!",
        timeout: 3000,
        type: "success",
        position: "top",
      });
    }
  },

  async updateUserData(payload) {
    try {
      await api.post("/api/user/data", payload);

      if (payload.image) {
        const formData = new FormData();
        formData.append("file", payload.image);

        await api.post(`/api/files/${payload.id}/upload/user_photo`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      this.user = await this.getUserData();
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "All changes have been saved!",
        timeout: 3000,
        type: "success",
        position: "top",
      });
    } catch (err) {
      console.log(err);
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "All changes have been saved!",
        timeout: 3000,
        type: "success",
        position: "top",
      });
    }
  },

  async login(payload) {
    try {
      const resp = await api.post("/api/auth/login", payload);
      this.setTokens(resp.data);
      router.push("/dashboard");
      // await this.autoLogin()
    } catch (err) {
      console.log(err);
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "Something is wrong. Please try again!",
        timeout: 3000,
        type: "error",
        position: "top",
      });
    }
  },

  async resetPassword(payload) {
    try {
      await api.post(`/api/auth/change-password?key=${payload.key}`, {
        password: payload.password,
      });
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "Password has been updated",
        timeout: 3000,
        type: "success",
        position: "top",
      });
      router.push("/");
    } catch (err) {
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "Something is wrong. Please try again!",
        timeout: 3000,
        type: "error",
        position: "top",
      });
    }
  },

  async requestPassword(payload) {
    try {
      await api.post(`/api/auth/request-password`, {
        password: null,
        email: payload.email,
      });
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "Request was successful. Please check your email.",
        timeout: 3000,
        type: "success",
        position: "top",
      });
    } catch (err) {
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "Something is wrong. Please try again!",
        timeout: 3000,
        type: "error",
        position: "top",
      });
    }
  },

  async autoLogin() {
    if (
      this.user == null &&
      this.accessToken != null &&
      this.accessToken != "null"
    ) {
      await this.getUserData();
    }
  },

  logout() {
    this.setTokens({ accessToken: null, refreshToken: null });
    this.authenticated = false;
    router.push("/");
  },

  setTokens(payload) {
    this.accessToken = payload.accessToken;
    this.refreshToken = payload.refreshToken;
    this.roles = payload.roles;

    localStorage.setItem("accessToken", payload.accessToken);
    localStorage.setItem("refreshToken", payload.refreshToken);
    localStorage.setItem("roles", payload.roles);
  },
});

export default actions;
